module.exports = "/6fa35e536d2099fb6f783ce4d3d87f9a.svg";